module.exports = __webpack_public_path__ + "static/media/k_logo-1.ec9b8ec6.png";